import axios from "axios";

export const API = axios.create({
  baseURL: "/api"
});

// ✅ Attach token ALWAYS
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`
    };
  }

  return config;
});

// ❌ NO reload here (avoid white screen)
API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      console.warn("Unauthorized - Token issue");
    }
    return Promise.reject(err);
  }
);
